import React from "react";
import styles from "./styles.module.scss";

export function Note({ children }) {
  return <div className={styles.root}>{children}</div>;
}
